// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

import SummarizeIcon from '@mui/icons-material/Summarize';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PaymentsIcon from '@mui/icons-material/Payments';
import WarehouseIcon from '@mui/icons-material/Warehouse';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

const icoMenu = {
    SummarizeIcon,
    AccountBalanceIcon,
    PaymentsIcon,
    WarehouseIcon
};

const reportes = {
    id: 'reporteria',
    title: '',
    type: 'group',
    children: [
        {
            id: 'reportes_menu',
            title: 'Reportería',
            type: 'collapse',
            icon: icoMenu.SummarizeIcon,
            children: [                
                {
                    id: 'comprobantes',
                    title: 'Comprobantes',
                    type: 'item',
                    url: '/user/reportes-comprobantes-view'
                },
                {
                    id: 'mayor_contable',
                    title: 'Mayores',
                    type: 'item',
                    url: '/user/reportes-mayor-contable-view'
                },
                {
                    id: 'comprobantes_descuadrados',
                    title: 'Comprobantes Descuadrados',
                    type: 'item',
                    url: '/user/reportes-comprobantes-descuadrados-view'
                },
                {
                    id: 'super_cias_reportes',
                    title: 'Super Cias',
                    type: 'collapse',
                    icon: icoMenu.PaymentsIcon,
                    children: [
                        {
                            id: 'super_cias_flujo_efectivo',
                            title: 'Flujos de Efectivo',
                            type: 'item',
                            url: '/user/reportes-super-cias-flujo-efectivo-view'
                        }
                    ]
                },
                {
                    id: 'financieros_reportes',
                    title: 'Financieros',
                    type: 'collapse',
                    icon: icoMenu.AccountBalanceIcon,
                    children: [
                        {
                            id: 'balance_comprobacion',
                            title: 'Balance de Comprobación',
                            type: 'item',
                            url: '/user/reportes-balance-comprobacion-view'
                        },
                        {
                            id: 'balance_comprobacion_totalizado',
                            title: 'Balance Comprobación Totalizado',
                            type: 'item',
                            url: '/user/reportes-balance-comprobacion-view?modo=totalizado'
                        },

                        {
                            id: 'estado_situacion_inicial',
                            title: 'Estado Situacion Inicial (Balance General)',
                            type: 'item',
                            url: '/user/reportes-estado-situacion-inicial-view'
                        },
                        {
                            id: 'estado_situacion_inicial_mensual',
                            title: 'Estado Situación Inicial Mensual',
                            type: 'item',
                            url: '/user/reportes-estado-situacion-inicial-mensual-view'
                        },
                        {
                            id: 'estado_resultados_financieros',
                            title: 'Estado Resultados',
                            type: 'item',
                            url: '/user/reportes-financieros-estado-resultados-view'
                        },
                        {
                            id: 'estado_resultados_mensual_financieros',
                            title: 'Estado Resultados Mensual',
                            type: 'item',
                            url: '/user/reportes-financieros-estado-resultados-mensual-view'
                        },
                        {
                            id: 'carga_estado_resultados_mensual',
                            title: 'Carga ER períodos históricos',
                            type: 'item',
                            url: '/user/reportes-carga-estado-resultados-mensual-view'
                        },
                        {
                            id: 'balance_general_financieros',
                            title: 'Balance General',
                            type: 'item',
                            url: '/user/reportes-balance-general-view'
                        }
                    ]
                },
                {
                    id: 'activos_fijos_reportes',
                    title: 'Activos Fijos',
                    type: 'collapse',
                    icon: icoMenu.WarehouseIcon,
                    children: [
                        {
                            id: 'activos_fijos',
                            title: 'Activos Fijos',
                            type: 'item',
                            url: '/user/reportes-activos-fijos-view'
                        }
                    ]
                },
                {
                    id: 'reportes_de_control',
                    title: 'Reportes de Control',
                    type: 'collapse',
                    icon: icoMenu.WarehouseIcon,
                    children: [
                        {
                            id: 'inventario_diario_medicamentos',
                            title: 'Inventario diario medicamentos',
                            type: 'item',
                            url: '/user/reportes-inventario-diario-medicamentos-view'
                        }
                    ]
                },
                {
                    id: 'reportes_productos',
                    title: 'Productos',
                    type: 'collapse',
                    icon: icoMenu.WarehouseIcon,
                    children: [
                        {
                            id: 'rotacion_productos',
                            title: 'Rotación Productos',
                            type: 'item',
                            url: '/user/reportes-rotacion-productos-view'
                        }
                    ]
                },
                {
                    id: 'reportes_arcsa',
                    title: 'Reporte ARCSA',
                    type: 'collapse',
                    icon: icoMenu.WarehouseIcon,
                    children: [
                        {
                            id: 'tipos_productos_almacenamiento',
                            title: 'Tipos de almacenamiento y distribución',
                            type: 'item',
                            url: '/user/reportes-arcsa-tipos-almacenamiento-view'
                        }
                    ]
                },
                {
                    id: 'caja_ventas_reportes',
                    title: 'Caja Ventas',
                    type: 'collapse',
                    icon: icoMenu.PaymentsIcon,
                    children: [
                        {
                            id: 'reporte_cierre_caja_web',
                            title: 'Reporte de caja web',
                            type: 'item',
                            url: '/user/reportes-cierre-caja-web-view'
                        },
                        {
                            id: 'estado_cajas_ventas',
                            title: 'Estado Cajas Ventas',
                            type: 'item',
                            url: '/user/estado-cajas-ventas-view'
                        }
                    ]
                },
                {
                    id: 'cuentas_por_cobrar_reportes',
                    title: 'Cuentas por Cobrar',
                    type: 'collapse',
                    icon: icoMenu.PaymentsIcon,
                    children: [
                        {
                            id: 'reporte_cxc_general',
                            title: 'Reporte general',
                            type: 'item',
                            url: '/user/reportes-cxc-general-view'
                        },
                        {
                            id: 'reporte_cxc_por_cliente',
                            title: 'Reporte por cliente',
                            type: 'item',
                            url: '/user/reportes-cxc-por-cliente-view'
                        },
                        {
                            id: 'consulta_cxc_por_cliente',
                            title: 'Consulta por cliente',
                            type: 'item',
                            url: '/user/consulta-cxc-por-cliente-view'
                        }
                    ]
                },
                {
                    id: 'cuentas_por_pagar_reportes',
                    title: 'Cuentas por Pagar',
                    type: 'collapse',
                    icon: icoMenu.PaymentsIcon,
                    children: [
                        {
                            id: 'reporte_cxp_proveedores',
                            title: 'Reporte de proveedores',
                            type: 'item',
                            url: '/user/reportes-cxp-view'
                        }
                    ]
                },
                {
                    id: 'reportes_ats',
                    title: 'Reportes ATS',
                    type: 'collapse',
                    icon: icoMenu.SummarizeIcon,
                    children: [
                        {
                            id: 'reportes_ats_ventas',
                            title: 'Ventas',
                            type: 'item',
                            url: '/user/reportes-ats-ventas-view'
                        },
                        {
                            id: 'reportes_ats_compras',
                            title: 'Compras',
                            type: 'item',
                            url: '/user/reportes-ats-compras-view'
                        },
                        {
                            id: 'reportes_ats_retenciones_emitidas',
                            title: 'Retenciones Emitidas',
                            type: 'item',
                            url: '/user/reportes-ats-retenciones-emitidas-view'
                        },
                        {
                            id: 'reportes_ats_anulaciones_autorizaciones',
                            title: 'Anulaciones / Autorizaciones',
                            type: 'item',
                            url: '/user/reportes-ats-anulaciones-autorizaciones-view'
                        },
                        {
                            id: 'reportes_ats_comprobantes_anulados',
                            title: 'Comprobantes Anulados (SRI)',
                            type: 'item',
                            url: '/user/reportes-ats-comprobantes-anulados-view'
                        },
                        {
                            id: 'reportes_ats_formas_pago',
                            title: 'Formas de Pago',
                            type: 'item',
                            url: '/user/reportes-ats-formas-pago-view'
                        },
                        {
                            id: 'reportes_ats_sustento_tributario',
                            title: 'Sustento Tributario',
                            type: 'item',
                            url: '/user/reportes-ats-sustento-tributario-view'
                        },
                        {
                            id: 'reportes_ats_iva_compras_ventas',
                            title: 'IVA Compras y Ventas',
                            type: 'item',
                            url: '/user/reportes-ats-iva-compras-ventas-view'
                        },
                        {
                            id: 'reportes_ats_retenciones_recibidas',
                            title: 'Retenciones Recibidas',
                            type: 'item',
                            url: '/user/reportes-ats-retenciones-recibidas-view'
                        },
                        {
                            id: 'reportes_ats_reembolsos_gastos',
                            title: 'Reporte de Reembolsos',
                            type: 'item',
                            url: '/user/reportes-ats-reembolsos-gastos-view'
                        }
                    ]
                }
            ]
        },
    ]
};

export default reportes;
